
import axios from 'axios'
import { fetchAccessToken, handleErrorResponse, handleErrorNoResponse } from '../../api'



const apiServer = axios.create({
  baseURL: `${window.location.origin}/api/v1/tiers`,
  headers: {
    common: {
      'Content-Type': 'application/json',
    },
  },
  mode: 'cors',
})
const CancelToken = axios.CancelToken
const source = CancelToken.source()

apiServer.interceptors.request.use(async (r) => {
  //Obtain and pass along Authorization token
  const authorizationToken = await fetchAccessToken()
  r.headers.Authorization = "Bearer " + authorizationToken

  //Configure the AbortSignal
  if (r.signal) {
    r.signal.onabort = () => {
      source.cancel()
    }
  }
  r.cancelToken = source.token

  return r
})

//API Aborted class
class Aborted extends Error {
  constructor(message, cause) {
    super(message)
    this.aborted = true
    this.cause = cause
  }
}
const tierAPI = {
  fetchAll: async (ops) => {
    const { signal } = ops

    try {
      const response = await apiServer.get('/', { signal })
      return response.data
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log('API call cancelled')
        throw new Aborted('Call aborted', err)
      } else {
        console.error(err)
        throw Error('Unable to fetch tiers')
      }
    }
  },
  create: async (tierData, ops) => {
    const { signal } = ops

    try {
      const authorizationToken = await fetchAccessToken()
      const response = await fetch(`${window.location.origin}/api/v1/tiers/`, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({
          ...tierData,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer " + authorizationToken,
        },
      })
      return await handleErrorResponse(response)
    } catch (err) {
      console.error(err)
      throw Error('Unable to create tier')
    }
  },
  update: async (tierData, ops) => {
    const { signal } = ops

    try {
      const authorizationToken = await fetchAccessToken()
      const response = await fetch(`${window.location.origin}/api/v1/tiers/${tierData.id}`, {
        method: 'PUT',
        mode: 'cors',
        body: JSON.stringify({
          ...tierData,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer " + authorizationToken,
        },
      })
      console.log('tier api update response', response)
      return await handleErrorResponse(response)
    } catch (err) {
      console.error(err)
      throw Error('Unable to edit tier.')
    }
  },
  fetchTier: async (tierId, ops) => {
    const { signal } = ops

    try {
      const authorizationToken = await fetchAccessToken()
      const response = await fetch(`${window.location.origin}/api/v1/tiers/${tierId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer " + authorizationToken,
        },
      })
      return await handleErrorResponse(response)
    } catch (err) {
      console.error(err)
      throw Error(`Unable to fetch tier: ${tierId}`)
    }
  },
  delete: async (values, ops) => {
    const { signal } = ops
    const { tierId, history } = values

    try {
      const response = await apiServer.delete(`/${tierId}`, { signal })
      history.push('/tiers')
      return response.data
    } catch (err) {
      if (axios.isCancel(err)) {
        throw new Aborted('Call aborted', err)
      } else {
        console.error(err)
        throw Error(`Unable to delete tier ${tierId}`)
      }
    }
  },
  /**
   * Determines if err is from a Cancelled or Aborted request
   * @param err
   */
  isCancel: (err) => {
    if (err.aborted && err.aborted === true) {
      return true
    }
    return false
  },
}

export default tierAPI
